module.exports = __webpack_public_path__ + "static/media/ic-filter.13aca106.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ic-filter.svg
// module id = 778
// module chunks = 0